import {Routes} from '@angular/router';
import {authGuard} from './core/guards/auth.guard';
import {developRoutes} from "./pages/develop/develop.route";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'editor/home',
    pathMatch: 'full',
  },
  {
    path: 'editor',
    loadChildren: () => import('./pages/editor/editor.route').then(m => m.editorRoutes),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.route').then(m => m.editorRoutes),
    canActivate: []
  },
  {
    path: 'develop',
    loadChildren: () => import('./pages/develop/develop.route').then(m => m.developRoutes),
    canActivate: []
  },
  {
    path: '**',
    redirectTo: 'editor/home',
    pathMatch: 'full'
  }
];
